// Branding bridge — contained estimating module reads Elite's real
// branding (app name, logo, and the three admin-managed hero videos)
// from the public /api/branding endpoint via the main app's cached
// loader. Empty video fields mean the dialogs fall back to the bundled
// /uploading.mp4 default.

import { useEffect, useState } from "react";
import { loadBranding } from "../../lib/branding";

export function useBranding() {
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    let active = true;
    loadBranding().then((data) => {
      if (active) setBranding(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return {
    companyName: branding?.app_name || "",
    company_name: branding?.app_name || "",
    logoUrl: branding?.logo_url || null,
    logo_url: branding?.logo_url || null,
    videoUploadUrl: branding?.video_upload_url || null,
    videoAnalyzeUrl: branding?.video_analyze_url || null,
    videoEstimateUrl: branding?.video_estimate_url || null,
  };
}
